export default __webpack_public_path__ + "static/media/9.a0fcef35.jpeg";